<template>
  <div class="modal-wrapper" v-if="visible">
    <p class="modal-title">수료 기준</p>
    <p class="modal-sub">이 과정의 수료기준은 다음과 같습니다.</p>
    <div v-html="contents"></div>
    <p class="modal-ok" @click="closeComplete">확인</p>
  </div>
</template>

<script>
import { watch } from "@vue/runtime-core";
export default {
  emits: ["closeModal"],
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    contents: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props, context) {
    const closeComplete = () => {
      context.emit("closeModal");
    };

    watch(
      () => props.visible,
      (cur) => {
        if (cur) {
        }
      }
    );

    return {
      closeComplete,
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: url(@/assets/imgs/enrolment/bg.png) no-repeat center / cover;
  width: 550px;
  padding: 48px 30px 36px 30px;

  .modal-title {
    font-size: 32px;
    font-weight: $bold;
    margin-bottom: 6px;
  }

  .modal-sub {
    margin-bottom: 32px;
  }

  .modal-ok {
    font-weight: $bold;
    color: $white;
    text-align: center;
    max-width: 164px;
    margin: 0 auto;
    padding: 16px 67px;
    background-color: $blue;
    border-radius: 8px;
    cursor: pointer;
    margin-top: 26px;
  }
}
</style>
